"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _logger = require("@studio/logger");
var _constants = require("@studio/constants");
var _program = require("@studio/program");
var _setSceneLayout = _interopRequireDefault(require("./setSceneLayout"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * @param {Object} attendeeIds a map of attendeeIds. { someAttendeeId: 'someAttendeeId' }
 */
var _default = exports["default"] = function _default(attendeeIds, setProgram) {
  return function (dispatch, getState) {
    var _getState = getState(),
      program = _getState.program,
      attendeeCameraStatus = _getState.attendeeCameraStatus;
    var programLayoutId = program._id;
    var layout = _constants.SceneLayouts.find(function (l) {
      return l.id === programLayoutId;
    });
    var layers = (0, _program.getProgramLayers)(program);
    var layerSource = layers.filter(function (layer) {
      return attendeeIds[layer.source.value];
    });

    // If source is in program we update the program scene
    if (layerSource.length) {
      var scene = _objectSpread(_objectSpread({}, program), {}, {
        layers: layers.map(function (ls) {
          var isCameraOn = attendeeCameraStatus[ls.source.value];
          if (typeof isCameraOn === 'boolean' && ls.layer) {
            ls.layer.isCameraOn = isCameraOn;
          }
          return ls;
        })
      });

      /*
        If it's a scene action i.e, when a scene is taken live,
        the layout is not valid, we don't want to set this.
      */
      if (layout) {
        dispatch((0, _setSceneLayout["default"])(layout));
      }
      // Dispatch action to setProgram
      dispatch(setProgram(scene, true, {
        emitSocket: false
      }));
      (0, _logger.logProgramChange)('updateProgramByCameraSource action');
    }
  };
};